import { isQuarantineTank } from '../../../shared/tank-purpose.js';

// Marks a quarantine or hospital tank wherever the tank is named, so a
// keeper never mistakes its logged-only readings for a display's.
export function QuarantineBadge({ tank, style }) {
  if (!isQuarantineTank(tank)) return null;
  return (
    <span className="qt-badge" style={style} title="Quarantine or hospital tank">
      Quarantine
    </span>
  );
}
